/**
 * Trigger a browser download of a text content as a file
 * @param {string} content - File content
 * @param {string} fileName - Downloaded file name
 * @param {string} [mimeType='text/plain'] - File MIME type
 * @returns {void}
 */
export const downloadTextFile = (content, fileName, mimeType = 'text/plain') => {
  const blob = new Blob([content], { type: `${mimeType};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
